export * from "./GenericLegend";
